import React from "react";
import styled from "styled-components";
import about1 from "../img/ab1.jpeg";
import { motion } from "framer-motion";
import { skillsData } from "../Data";
import useScroll from "./useScroll";
import {
  pageAnimation,
  photoAnimation,
  scrollRevealRight,
  titleAnimRev,
  upDown,
} from "../animation";

const MyAbout = () => {
  const [element, controls] = useScroll();
  return (
    <AboutWrapper
      variants={pageAnimation}
      exit="exit"
      initial="hidden"
      animate="show"
    >
      <motion.h1 variants={titleAnimRev} initial="hidden" animate="show">
        About Me
      </motion.h1>
      <AboutSectionWrapper>
        <MyImage variants={photoAnimation} initial="hidden" animate="show">
          <img
            src={about1}
            alt="abtImage"
          ></img>
        </MyImage>
        <MyIntro variants={scrollRevealRight} animate="show" initial="hidden">
          <p>
            <b>I'm</b> a 21-year-old Integrated M.Tech student at <b>IIT Dhanbad</b>{""},
            specializing in Mathematics and Computing, with a strong foundation in AI, 
            Machine Learning, and Data Science. Currently serving as an AI SDE Intern 
            at Intel Corporation, I'm working on optimizing and deploying AI models using frameworks like PyTorch and OpenVINO.
          </p>
          <p>
          Through these experiences, including my Data Science internship at Get 
          Better Studios, I've had the opportunity to create impactful solutions 
          - from optimizing large language models to developing comprehensive data 
          analytics pipelines. I now spend significant time on fine-tuning models and 
          improving analytical approaches, focusing on both performance and efficiency.
          </p>
          <p>
          I'm passionate about transforming complex data into actionable insights and 
          developing AI solutions that make a real difference. Whether it's implementing 
          deep learning models or creating interactive dashboards, I strive to deliver 
          solutions that are not only powerful but also maintainable and scalable.
          </p>
        </MyIntro>
      </AboutSectionWrapper>
      <SkillsWrapper>
        <motion.h1>Skills</motion.h1>
        <SkillsDes>
        I have a strong foundation in <span>Data Structures and Algorithms</span>, 
        developed through competitive programming and my 
        academic background at IIT Dhanbad. In addition to that, I have extensive 
        experience with <span>Python</span>, <span>PyTorch</span>, and <span>Machine 
          Learning</span>, applying them in real-world projects at Intel and Get 
          Better Studios. My expertise extends to <span>Power BI</span>, <span>Tableau</span>,
          <span> OpenVINO</span>, and <span>Deep Learning</span>, which I've utilized 
          to optimize AI models and create impactful data visualizations.
        </SkillsDes>
        <Skills>
          {skillsData.map((data, index) => (
            <Skill
              ref={element}
              variants={upDown}
              animate={controls}
              initial="hidden"
              key={index}
              custom={index}
              whileHover={{ scale: 1.1 }}
            >
              {data}
            </Skill>
          ))}
        </Skills>
      </SkillsWrapper>
    </AboutWrapper>
  );
};

const Skills = styled(motion.div)`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 25px;
  color: grey;
  font-size: large;
  max-width: 90vh;
  margin: 3rem auto 7rem;
  @media (max-width: 750px) {
    padding: 0rem 2rem;
  }
  @media (max-width: 500px) {
    padding: 0rem 2rem;
  }
`;

const Skill = styled(motion.div)`
  border: 1px solid white;
  padding: 0.6rem 1rem;
  border-radius: 15px;
  box-shadow: 0px 0px 15px rgba(231, 229, 229, 0.4);
  cursor: pointer;
  transition: transform 1s ease;
  &:hover {
    box-shadow: 0px 0px 15px rgba(244, 161, 98, 0.9);
    color: black;
    background-color: grey;
    border: black;
  }
  @media (max-width: 500px) {
    font-size: 1.1rem;
  }
`;

const AboutWrapper = styled(motion.div)`
  overflow: hidden;
  h1 {
    display: flex;
    justify-content: center;
    padding: 3rem 3rem;
    color: #8b4612;
    font-size: 3.5rem;
  }
`;

const AboutSectionWrapper = styled(motion.div)`
  display: flex;
  padding: 3rem 8rem;
  align-items: center;
  justify-content: center;
  @media (max-width: 1200px) {
    padding: 3rem 1rem;
  }
  @media (max-width: 800px) {
    flex-direction: column;
  }
  @media (max-width: 500px) {
    padding: 1rem 1rem;
  }
`;

const MyImage = styled(motion.div)`
  overflow: hidden;
  flex: 1;
  display: flex;
  justify-content: center;
  img {
    width: 30rem;
    line-height: 0px;
    overflow: hidden;
    object-fit: cover;
    transition: transform 1s ease;
    &:hover {
      transform: scale(1.1);
    }
  }
  @media (max-width: 1200px) {
    flex: 2;
  }
  @media (max-width: 500px) {
    width: 20rem;
    height: 30rem;
  }
`;

const MyIntro = styled(motion.div)`
  display: flex;
  flex: 2;
  flex-direction: column;
  padding: 1rem 0rem 1rem 4rem;
  p {
    padding: 1rem 0rem;
    font-size: 1.7rem;
    b {
      display: inline-block;
      color: #23d997;
      font-size: 2.5rem;
      @media (max-width: 500px) {
        font-size: 1.5rem;
      }
    }
    @media (max-width: 500px) {
      font-size: 1.2rem;
    }
  }
  @media (max-width: 1200px) {
    padding: 1rem 0rem 1rem 2rem;
  }
`;

const SkillsWrapper = styled(motion.div)`
  h1 {
    display: flex;
    justify-content: center;
    padding: 3rem 3rem;
    color: #8b4612;
    font-size: 3.5rem;
  }
`;

const SkillsDes = styled(motion.div)`
  max-width: 900px;
  font-size: 1.9rem;
  color: white;
  margin: auto;
  padding: 0rem 2rem;
`;

export default MyAbout;
